<template v-if="Showpage">
  <div>
    <a-button class="editable-add-btn" @click="handleAdd">
      Add
    </a-button>
    <a-table bordered :data-source="data" :columns="columns">
      <template slot="operation" slot-scope="text, record">
        <a-popconfirm
          v-if="data.length"
          title="Sure to delete?"
          @confirm="() => onDelete(record.id)"
        >
          <a href="javascript:;">Delete</a>
        </a-popconfirm>
      </template>
    </a-table>
</div>
</template>
<script>
const columns = [
  {
    title: 'id',
    dataIndex: 'id',
    key: 'id'
  },
  {
    title: 'name',
    dataIndex: 'name',
    key: 'name',
  },
  {
    title: 'operation',
    dataIndex: 'operation',
    scopedSlots: { customRender: 'operation' },
  },
];


export default {
  data() {
    let param = {
        page:1,
        pagenum:10
    }
    let userlist;
    let obj = this.$qs.stringify(param)
    this.$axios({
      method:'post',
      url:'/api/user/list',
      data: obj
    }).then((response) =>{          //这里使用了ES6的语法
       this.data = response.data
       this.Showpage = true
       console.log(response)       //请求成功返回的数据
    }).catch((error) =>{
         console.log(error)       //请求失败返回的数据       
    })
    return {
      Showpage:false,
      data:userlist,
      columns
    };
  },
  created(){
    this.InitData()
  },
  methods: {
    onDelete(key) {
      let param = {
        id:key
    }
    let obj = this.$qs.stringify(param)
    this.$axios({
      method:'post',
      url:'/api/user/delete',
      data: obj
    }).then((response) =>{          //这里使用了ES6的语法
       console.log(response)       //请求成功返回的数据
       const data = [...this.data];
       this.data = data.filter(item => item.id !== key);
    }).catch((error) =>{
         console.log(error)       //请求失败返回的数据       
    })
    },
    handleAdd(){
    this.$router.push('/home/newuser')
    },
    onShowSizeChange(current, pageSize) {
      this.pageSize = pageSize;
    },
    InitData(){
    let param = {
        page:1,
        pagenum:10
      }
    let obj = this.$qs.stringify(param)
    this.$axios({
      method:'post',
      url:'/api/user/list',
      data: obj
    }).then((response) =>{          //这里使用了ES6的语法
       this.data = response.data
       this.Showpage = true
       console.log(response)       //请求成功返回的数据
    }).catch((error) =>{
         console.log(error)       //请求失败返回的数据       
    })
    }
  },
  
};
</script>
<style>
.editable-add-btn {
  margin-bottom: 8px;
}
</style>


// WEBPACK FOOTER //
// src/components/UserList.vue